import { ROUTE, ROUTE_TITLE_PREFIX } from "../../misc";
import { appEventGTag, EventPage } from "../event";

export const event = (page: EventPage, location: string, previousPath: string, previousLocation: string) => {
    const routeKey = Object.keys(ROUTE).find(key => {
        return ROUTE[key] === previousPath;
    });

    appEventGTag({
        page: page,
        previousPage: ROUTE_TITLE_PREFIX?.[routeKey],
        eventName: "page_visit",
        eventLocationType: "page_location",
        eventLocationLabel: "page",
        eventPagePathname: location,
        eventPreviousPagePathname: previousLocation,
        eventLabel: "Page visit"
    });
};
